import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";
import { FAQS } from "@/data/site";

export default function FAQ({ index = "/04", labelText = "Common questions" }) {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="py-24 md:py-32 border-t border-zinc-200">
      <div className="container-tight grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Reveal>
            <SectionLabel index={index} testid="faq-label">{labelText}</SectionLabel>
            <h2 className="mt-6 font-display text-4xl md:text-5xl text-zinc-900 tracking-tighter leading-[1.05]">
              Answers
              <br /><span className="text-zinc-400">before you ask.</span>
            </h2>
            <p className="mt-6 text-zinc-600 leading-relaxed text-[15px]">
              Six honest answers to the questions most prospects bring to the first call.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-8 border-t border-zinc-200">
          {FAQS.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <Reveal key={item.q} delay={idx * 0.04}>
                <div data-testid={`faq-item-${idx}`} className="border-b border-zinc-200">
                  <button
                    type="button"
                    data-testid={`faq-toggle-${idx}`}
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    aria-expanded={isOpen}
                    className="w-full py-6 flex items-center justify-between gap-6 text-left group"
                  >
                    <span className="font-display text-lg md:text-xl text-zinc-900 tracking-tight group-hover:opacity-80 transition">
                      {item.q}
                    </span>
                    <span
                      className={`shrink-0 w-9 h-9 inline-flex items-center justify-center border ${
                        isOpen ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 text-zinc-700"
                      } transition-colors`}
                    >
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        key="content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-12 text-zinc-600 text-[15px] leading-relaxed">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
